export default __webpack_public_path__ + "static/logoSynergyWeb-335fda6622815e690431eaf9d6a3ac35.png";